<template>
  <div>
    <section class="container">
      <div class="columns is-multiline">
        <div class="column is-three-fifths is-offset-one-fifth">
          <div class="notification">
            <router-link to="/">
              <div class="logo"></div>
            </router-link>
            <h2 class="title is-4 has-text-primary">Reset Password</h2>
            <p class="info-text">Enter your new password.</p>
            <form @submit.prevent="submit">
              <div class="field">
                <div class="control">
                  <input
                    class="input is-medium"
                    type="password"
                    placeholder="Password"
                    v-model.trim="$v.form.password.$model"
                    :class="{'is-danger' :$v.form.password.$error}"
                  />
                  <div class="error" v-if="$v.form.password.$error">Password is required</div>
                </div>
              </div>

              <div class="field">
                <div class="control">
                  <input
                    class="input is-medium"
                    type="password"
                    placeholder="Confirm Password"
                    v-model.trim="$v.form.passwordConfirmation.$model"
                    :class="{'is-danger' :$v.form.passwordConfirmation.$error}"
                  />
                  <div class="error" v-if="$v.form.passwordConfirmation.$error">Passwords must match</div>
                </div>
              </div>

              <b-button
                native-type="submit"
                class="button is-block is-fullwidth is-medium"
                :class="[$v.$invalid ? 'disabled' : 'is-primary']"
              >Submit</b-button>
            </form>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { required, sameAs } from 'vuelidate/lib/validators'
import AuthService from '../services/auth.service'

export default {
  name: 'ResetPassword',
  data() {
    return {
      form: {
        code: this.$route.query.code,
        password: '',
        passwordConfirmation: '',
      },
    }
  },
  methods: {
    submit() {
      console.log('submitting: ' + JSON.stringify(this.form))
      AuthService.resetPassword(this.form)
        .then(response => {
          console.log('password sent, response: ' + JSON.stringify(response))
          this.$router.push('/')
        })
        .catch(error => {
          console.log('error resetting password: ' + error.response)
        })
    },
  },
  validations: {
    form: {
      password: {
        required,
      },
      passwordConfirmation: {
        sameAsPassword: sameAs('password'),
      },
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../theme.scss';

:root {
  --brandColor: $primary;
  --background: rgb(247, 247, 247);
  --textDark: hsla(0, 0%, 0%, 0.66);
  --textLight: hsla(0, 0%, 0%, 0.33);
}

.logo {
  background-image: url('~@/assets/logo.png');
  width: 250px;
  height: 150px;
  background-size: cover;
  margin-bottom: 25px;
  margin-left: auto;
  margin-right: auto;
}

.notification {
  margin: 5rem;
  background: white;
}

.title {
  text-align: center;
}

.button,
.input {
  margin: 0.5rem;
}

.error,
.info-text {
  margin-left: 0.5rem;
}

.disabled {
  cursor: not-allowed;
}
</style>